exports.agreement1 = `<b>제1장 총칙</b>

  제1조(목적) 본 약관은 NCS평가관리시스템 사이트가 제공하는 서비스(이하 "서비스"라 한다)를 이용하기 위한 기준 및 절차, 이용자와 사이트의 권리ㆍ의무, 기타 필요한 사항을 정함을 목적으로 합니다.

  제2조(용어의 정의) 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
  1. 이용자란 사이트가 제공하는 서비스를 이용하는 자를 말합니다.
  2. 회원이란 본 약관에 동의하고, 정상적으로 ID와 Password를 발급받아 이용할 수 있는 권한을 부여받은 개인을 말합니다.
  3. 관리자란 동 약관의 체결과 사이트의 기획, 관리 및 운영에 관한 총괄책임자인 한국스마트ICT융합협회(KSICA)와 그 업무의 일부 또는 전부를 위탁받은 기관, 법인 및 단체를 포함합니다.

  제3조(약관의 효력과 변경)
  ① 동 약관은 사이트 게시판에 게시되고, 귀하가 회원가입을 완료함으로써 그 효력이 발생합니다.
  ② 관리자가 동 약관을 변경하는 경우에는 적용일자와 변경사항을 명시하여 적용일자 7일 전에 사이트 게시판을 통해 공지하며, 공지된 적용일에 사이트 게시판에 공지와 동시에 그 효력이 발생합니다.
  ③ 관리자가 제2항에 따라 변경된 약관을 공지하면서 회원에게 변경된 약관의 적용일까지 거부의사를 표시하지 않으면 약관의 변경에 동의한 것으로 간주한다는 내용을 명확하게 공지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다. 이 경우 변경되어 공지된 약관의 내용을 알지 못 해 발생하는 회원의 피해는 관리자가 책임지지 않습니다.
  ④ 회원이 변경된 약관의 적용에 동의하지 않는 경우에는 서비스 이용을 중단하고, 이용계약을 해지할 수 있습니다.

  제5조(약관 외 준칙) 본 약관에 명시되지 않는 사항이 관계법령에 규정되어 있는 경우 그 규정을 따르며, 그렇지 않는 경우에는 일반적인 관례에 따릅니다.

  <b>제2장 서비스의 이용 및 제공</b>

  제4조(이용 계약의 성립)

  ① 이용계약은 이용자가 동 약관의 내용에 동의 한 후, ID 가입 신청을 하고, 관리자가 신청에 대하여 승인함으로써 성립됩니다.
  ② 가입 신청자는 회원가입 신청시 다음 각 호의 정보를 관리자에게 제공해야 합니다.
    1. 성명, 개인 식별키 등 실명인증 수단
    2. 전화번호, 이메일, 주소 등 연락처
    3. 기타 관리자가 정하는 사이트별 필요정보
  ③ 제2항 제3호에 따라 기타 관리자가 정하는 사항은 각 사이트별 서비스 제공에 필요한 정보로서 개인정보보호처리방침을 통해 관리합니다.

  제5조(이용계약의 취소 및 승인 유보)

  ① 관리자는 다음 각 호에 해당하는 경우에는 이용계약을 취소할 수 있습니다.
    1. 다른 사람의 명의를 사용하여 신청하였을 때
    2. 이용 계약 신청서의 내용을 허위로 기재하였거나 신청하였을 때
    3. 사회의 안녕 질서 혹은 미풍양속을 저해할 목적으로 신청하였을 때
    4. 기타 사이트가 정한 이용신청요건이 미비 되었을 때

  ② 관리자는 다음 각 호에 해당하는 경우에는 그 사유가 해소될 때까지 이용계약의 성립을 유보할 수 있습니다.
    1. 서비스 관련 제반 용량이 부족한 경우
    2. 기술상 장애 사유가 발생한 경우
    3. 기타 서비스의 효율적인 운영상 회원의 가입을 잠시 보류시켜야 할 사유가 발생한 경우

  제6조(서비스의 이용)
  ① 회원은 서비스별로 고지된 구체적인 서비스 내용, 이용 조건 등에 따라 해당 서비스를 이용할 수 있습니다.
  ② 사이트는 관련 법령 또는 사이트별 서비스 특성에 따라 회원을 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 달리 적용할 수 있습니다.

  제7조(서비스 이용시간) 서비스의 이용시간은 사이트의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다. 다만, 사이트 정기점검 등에 따라 일시적 중단이 필요한 경우에는 예외로 합니다.

  제8조(서비스의 중지 및 변경)
  ① 관리자는 다음 각 호의 사유가 발생한 경우에는 서비스의 전부 또는 일부를 중지 또는 변경할 수 있습니다.
    1. 서비스 관련 제반 용량이 부족한 경우
    2. 기술상 장애 사유가 발생한 경우
    3. 기타 관리자가 안정적인 서비스 제공을 현저하게 지속하기 어려운 사유가 발생한 경우
  ② 관리자는 제1항에 따른 서비스의 중지 및 변경에 대한 사유, 해당 서비스의 중지 및 변경 내용 및 적용일자 등을 명시하여 사이트 초기화면에 사전에 게시하여야 합니다. 다만, 관리자가 통제할 수 없는 사유로 인한 서비스의 중지 또는 변경에 대하여는 그러하지 아니합니다.
  ③ 관리자는 무료로 제공되는 서비스의 일부 또는 전부를 정책 환경 또는 내부 운영정책의 변화에 따라 중지 또는 변경할 수 있습니다.
  ④ 관리자는 서비스의 중지 또는 변경으로 인한 회원의 기대이익 상실에 대하여는 배상하지 않습니다.

  제9조(회원에 대한 통지)
  ① 사이트가 특정 회원에 대하여 통지를 하는 경우에는 동 약관에 별도의 규정이 없는 한 이메일, 전자쪽지 또는 핸드폰 문자메시지 등으로 할 수 있습니다.
  ② 사이트가 불특정 다수의 회원에 대하여 통지를 하는 경우에는 7일 이상 사이트 게시판에 게시함으로써 제1항에 따른 개별 통지에 갈음 할 수 있습니다.

  제10조(타 사이트의 연결)
  ① 사이트는 제공하는 서비스와 관련하여 제3자가 운영하는 타사이트를 하이퍼링크(문자, 그림 및 동영상 등 포함)방식 등을 통해 연결해주는 서비스를 제공할 수 있습니다.
  ② 사이트는 제1항에 따라 연결된 타사이트 서비스의 이용, 상품 또는 용역을 거래한 행위 등과 관련하여 아무런 책임을 부담하지 않습니다.

  제11조(이용계약의 해지 및 이용제한)
  ① 이용자가 서비스 이용계약을 해지하고자 하는 때에는 사이트에 본인이 직접 해지신청을 하여야 합니다.
  ② 관리자는 이용자가 다음 각 호에 해당하는 행위를 한 경우 사전 통지 없이 이용계약을 해지하거나 서비스의 전부 또는 일부의 제공하지 않을 수 있습니다.
    1. 타인의 아이디(ID) 및 비밀번호(Password)를 도용한 경우
    2. 다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등의 행위를 하였을 때
    3. 수신자의 의사에 반하는 광고성 정보, 전자우편을 전송하는 경우
    4. 사이트의 승인을 받지 아니한 광고, 판촉물, 정크메일, 스팸, 행운의 편지, 피라미드 조직 기타 다른 형태의 권유를 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 경우
    5. 서비스를 이용하여 얻은 정보를 사이트의 동의 없이 상업적으로 이용하는 경우
    6. 정보통신윤리위원회로부터의 이용제한 요구 대상인 경우
    7. 다른 이용자의 개인정보를 수집 또는 저장하는 행위
    8. 기타 사이트를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우

  제12조(위법ㆍ부적절한 게시물의 삭제) 제16조 제2항 각 호 및 다음 각 호의 사유에 해당하는 게시물의 경우 이용자의 동의 없이 삭제 될 수 있습니다.
    1. 다른 이용자 또는 제 3자를 비방하거나 중상모략으로 명예를 손상시키는 경우
    2. 해당 게시판의 운영 목적에 적합하지 않다고 판단되는 경우
    3. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등을 유포하는 경우
    4. 반국가적, 반사회적, 범죄적 행위와 결부된다고 판단되는 경우
    5. 게시 기간이 규정된 기간을 초과한 경우
    6. 기타 관계 법령에 위배된다고 판단되는 경우

  <b>제3장 권리과 의무</b>

  제13조(게시된 자료에 대한 권리)
  ① 게시물에 대한 권리와 책임은 게시자에게 있으며, 사이트는 게시자의 동의 없이는 이를 영리적 목적으로 사용할 수 없습니다. 단, 비영리적 목적인 경우 관리자는 게시자의 동의 없이도 이를 사용할 수 있으며 서비스내의 게재권을 갖습니다.
  ② 게시자의 사전 동의가 없이는 이용자는 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 서비스에 게재된 자료를 상업적 목적으로 이용할 수 없습니다.

  제14조(사이트의 의무)
  ① 사이트는 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적, 안정적으로 서비스를 제공하기 위해 노력할 의무가 있습니다.
  ② 사이트는 약관 변경사항의 공지 또는 회원에 대한 통지가 필요한 경우 해당 절차를 성실히 준수하여 수행합니다.

  제20조(이용자의 의무) 이용자는 이 약관에서 규정하는 사항과 서비스 이용안내 또는 주의사항을 준수하여야 하며, 다음 각 호에 해당하는 행위를 해서는 안됩니다.
    1. 제5조 제1항에 따른 이용계약 취소요건에 해당하는 행위
    2. 제11조 제2항 각 호에 따른 이용계약의 해지 또는 서비스의 전부 또는 일부 제한 요건에 해당하는 행위
    3. 제12조 각 호에 따른 위법ㆍ부적절한 내용을 담고 있는 게시물을 게재하는 행위

  제15조(개인정보보호와 정보주체의 권리)
  ① 사이트는 본 약관 제5조에 따라 회원정보를 수집, 관리, 이용, 보유 및 제공 등 처리하며, 개인정보보호법 등 관련 법령을 준수하고, 회원의 개인정보를 보호하기 위해 노력합니다.
  ② 회원의 개인정보에 대한 수집, 이용, 제공, 위탁 등(이하 "처리")의 구체적인 내용은 사이트 초기화면에 공지된 개인정보처리방침에 기재되어 있으며, 사이트는 회원의 회원 가입 신청 시 동 개인정보처리방침을 고지하고 이에 따라 회원의 개인정보를 처리합니다.
  ③ 사이트는 필요에 따라 개인정보처리방침의 내용을 변경할 수 있으며, 변경하는 경우에는 적용일자와 변경사항을 명시하여 사이트 게시판 등을 통해 공지토록 하겠습니다.
  ④ 이용자는 언제나 자신이 입력한 개인정보를 열람할 수 있으며, 오류를 수정 할 수 있습니다. 자세한 방법은 개인정보처리방침에 기재되어 있습니다.

  제16조(양도금지) 회원은 서비스의 이용권한, 기타 이용계약 상의 지위를 타인에게 양도 및 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.

  <b>제4장 분쟁의 해결</b>

  제17조(손해배상) 사이트는 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 동 손해가 당 사이트의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부담하지 아니합니다.

  제18조 (면책조항)
  ① 사이트는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
  ② 사이트는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
  ③ 회원이 서비스 제공으로부터 기대되는 이익을 얻지 못하였거나 서비스 자료에 대한 취사선택 또는 이용으로 발생하는 불이익에 대하여 사이트는 책임을 지지 아니합니다.
  ④ 사이트는 회원이 서비스 또는 콘텐츠와 관련하여 게재 또는 등록한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.
  ⑤ 사이트는 회원 간 또는 회원과 제3자간에 이루어진 일체의 분쟁에 대하여 아무런 책임을 지지 않습니다.

  제19조 (분쟁의 해결) 사이트는 서비스에 대한 회원의 이의제기나 불만이 발생하였을 경우에 회원이 제기하는 정당한 의견이나 불만에 대해 적절하고 신속한 조치를 취합니다. 다만, 신속한 처리가 곤란한 경우에 사이트는 회원에게 그 사유와 처리일정을 통보합니다.

  제20조 (관할법원) 본 서비스 이용과 관련하여 발생한 분쟁에 대해 소송이 제기될 경우 관리자가 속한 본원을 전속적 관할 법원으로 합니다. 이 경우 회원의 통합관리에 관한 사항에 관하여는 고용노동부를 서비스 제공에 관한 사항에 관하여는 해당 서비스 제공 기관의 본원을 관리자가 속한 본원으로 본다.

  <b>부칙</b>

  제1조 (시행일) 본 약관은 2017년 2월 01일부터 시행됩니다.
`

exports.agreement2 = `1. 수집하는 개인정보의 항목
ㅇ 회원정보
- 회원입력항목: ID, 비밀번호, 전화번호, 이름, 성별, 생년월일
- 자동수집항목: DI, CI, IP주소

2. 개인정보의 보유 및 이용기간
ㅇ 회원정보: 탈퇴시까지

3. 개인정보 수집에 대한 거부 권리 및 그에 따른 제한사항
ㅇ 이용자는 개인정보 수집에 대한 동의 요청을 거부할 권리가 있으며 거부할 경우 NCS평가와 관련된 서비스 이용에 제한을 받을 수 있습니다.
`

exports.agreement3 = `1. 개인정보의 수집·이용 목적
ㅇ KSICA는 각종 정보제공을 이메일로 제공하기 위해 개인정보를 수집‧이용 합니다.

2. 수집하려는 개인정보의 항목: 이메일

3. 개인정보의 보유 및 이용기간: 회원 탈퇴시까지

4. 개인정보 수집에 대한 거부 권리 및 그에 따른 제한사항
ㅇ 이용자는 KSICA가 수집하는 개인정보에 대해 동의를 거부할 권리가 있으나 각종 정보제공을 이메일로 받아보실 수 없습니다.

※ 상기 항목에 대해 동의를 거부할 수 있으나 회원가입시나 회원가입 후 개인정보수정시 선택정보를 입력할 경우 선택정보 수집 및 이용에 동의한 것으로 간주됩니다.
`

exports.agreement4 = `KSICA는 회원정보의 관리를 위해 아래와 같이 회원정보를 제공합니다.

1. 개인정보를 제공받는자
ㅇ 이용자가 신청한 교육을 운영하는 기관

2. 개인정보를 제공받는 자의 개인정보 이용 목적
ㅇ 회원 중복확인, 개인식별, 가입의사 확인, 회원제 서비스 이용 등 신청한 교육서비스와 연계된 회원정보관리

3. 제공하는 개인정보의 항목
ㅇ 회원정보
- 회원입력항목: ID, 비밀번호, 전화번호, 이름, 성별, 생년월일
- 자동수집항목: DI, CI, IP주소

4. 개인정보를 제공받는자의 개인정보 보유 및 이용기간: 회원탈퇴시까지
`
